import Marionette from 'backbone.marionette';
import viewMixins from './core/internal/viewMixins';

export default Marionette.CollectionView.extend(viewMixins(Marionette.CollectionView));
